import React from 'react';
import { applySizeToProps } from '../utils/applySizeToProps';
import { IconProps } from '../types';

export const IconArrowRightSmallOutline: React.FC<IconProps> = (props) => (
  <svg {...applySizeToProps(props)} xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24"><path fill="currentColor" fillRule="nonzero" stroke="currentColor" strokeWidth={0.5} d="m18.086 11.364-5.51-5.51a.5.5 0 1 1 .706-.708L20 11.864l-6.718 6.717a.5.5 0 1 1-.707-.707l5.51-5.51H4.5a.5.5 0 0 1 0-1z" /></svg>
);
